import {TextInput} from 'platform/components';

import {useState} from 'react';

import {isFalse} from 'ramda-adjunct';

import {TenantFieldDefinitionResponseBody} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId, useDebouncedCallback} from 'shared/web';

import {useUpdateEnum} from './hooks/useUpdateEnum';

interface EnumNameInputProps extends RequiredTestIdProps {
  definition: TenantFieldDefinitionResponseBody;
  enumOption: TenantFieldDefinitionResponseBody['enumOptions'][number];
}

export function EnumNameInput(props: EnumNameInputProps) {
  const [name, setName] = useState<string | null>(props.enumOption.name);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const {updateName} = useUpdateEnum(props.definition.id, props.definition.resource.id);

  const handleUpdateName = useDebouncedCallback((updatedName: string | null) => {
    updateName(props.enumOption.uuid, updatedName ?? '');
  }, 500);

  return (
    <TextInput
      type="text"
      value={name}
      onChange={(value) => {
        setName(value);
        if (props.definition.valueType === 'multi_enum' && value?.includes(',')) {
          setErrorMessage(i18n.t('page.generalSettings.labels.includesCommaMessage'));
          return;
        }
        setErrorMessage(null);
        handleUpdateName(value);
      }}
      isDisabled={isFalse(props.enumOption.active)}
      data-testid={suffixTestId('enumValue', props)}
      errorMessage={errorMessage}
      isRequired
      placeholder={i18n.t('page.generalSettings.labels.enumValue')}
    />
  );
}
